import { Expose } from 'class-transformer';

export class HcLotReleaseConfigResponseDto {
    /**
     * HC lot release configuration ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Client Information Record ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * Product ID reference
     * @example '123e4567-e89b-12d3-a456-426614174001'
     */
    @Expose()
    productId?: string;

    /**
     * QCO Contact ID for Health Canada submissions
     * @example '123e4567-e89b-12d3-a456-426614174002'
     */
    @Expose()
    qcoContactId?: string;

    /**
     * Client's RA contact for HC submissions
     * @example '123e4567-e89b-12d3-a456-426614174003'
     */
    @Expose()
    clientRaContactId?: string;

    /**
     * QP responsible for HC lot release
     * @example '123e4567-e89b-12d3-a456-426614174004'
     */
    @Expose()
    qpContactId?: string;

    /**
     * Submission deadline in days before expiry
     * @example 30
     */
    @Expose()
    submissionDeadlineDays?: number;

    /**
     * Is electronic submission required?
     * @example true
     */
    @Expose()
    electronicSubmissionRequired?: boolean;

    /**
     * HC submission portal reference
     * @example 'HC-PORTAL-2024'
     */
    @Expose()
    submissionPortalRef?: string;

    /**
     * Drug Identification Number (DIN)
     * @example 'DIN02234567'
     */
    @Expose()
    dinNumber?: string;

    /**
     * Drug Product Database (DPD) number
     * @example 'DPD123456'
     */
    @Expose()
    dpdNumber?: string;

    /**
     * Notes
     * @example 'Follow HC guidelines TPD-2024-001'
     */
    @Expose()
    notes?: string;


    @Expose()
    submissionEmailTo?: string;

    @Expose()
    submittedBy?: string;

    @Expose()
    group?: string;

    /**
     * Creation timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    updatedAt: Date;
}
